const Resources = {

    table_headers: [
        {
            text:   'S. Scenario',
            align:  'start',
            value:  'staffing_scenario'
        },
        { 
            text:   'Name',
            value:  'name'
        },
        {
            text:   'Number',
            value:  'number'
        },
        {
            text:   'Minutes',
            value:  'minutes'
        },
        {
            text:   'Days',
            value:  'days'
        }
    ],
    
    breadcrumb:[
        {
            name:   'Home',
            href:   '/',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Budgeting',
            href:   '#',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Staffing Scenarios',
            href:   '/budgeting-staffing-scenario',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'New Staffing Scenario',
            href:   '#',
            arrow:  "",
        },
    ],
    
    breadcrumb_update:[
        {
            name:   'Home',
            href:   '/',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Budgeting',
            href:   '#',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Staffing Scenarios',
            href:   '/budgeting-staffing-scenario',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Staffing Scenario Update',
            href:   '#',
            arrow:  "",
        },
    ],

}

export default Resources;